import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Toaster } from 'react-hot-toast';
import CookieConsent from 'react-cookie-consent';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './utility/ScrollToTop';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out-quart',
      once: true,
      offset: 100,
      delay: 0,
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />

      <main className="flex-grow">
        <Outlet />
      </main>

      <ScrollToTop />
      <Footer />
      <Toaster position="top-right" />
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        enableDeclineButton
        flipButtons={true}
        cookieName="projectProseConsent"
        style={{ background: "#1a1a1a", color: "#fff" }}
        buttonStyle={{ background: "#d4af37", color: "#000", fontWeight: "bold" }}
        declineButtonStyle={{ background: "transparent", color: "#fff", border: "1px solid #fff" }}
      >
        We use cookies to enhance your browsing experience and analyze site traffic. Please accept to continue.
      </CookieConsent>
    </div>
  );
}

export default App;